/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Tooltip, styled, tooltipClasses } from "@mui/material";

/**
 * @param {import("@mui/material").TooltipProps} props
 */
const ButtonTooltipBase = (props) => {
    
    const {
        children,
        className,
        ...otherProps
    } = props;
    return (
        <Tooltip
            classes={{ popper: className }}
            {...otherProps}
        >
            <span>
                {children}
            </span>
        </Tooltip>
    );
};

const ButtonTooltip = styled(ButtonTooltipBase)(({ theme }) => {
    return {
        [`& .${tooltipClasses.tooltip}`]: {
            boxShadow: theme.shadows[0],
            border: `1px solid ${theme.palette.grey[400]}`
        },
    };
});

export { ButtonTooltip };
